import { render, staticRenderFns } from "./IrWalletList.vue?vue&type=template&id=450074cc"
import script from "./IrWalletList.vue?vue&type=script&lang=js"
export * from "./IrWalletList.vue?vue&type=script&lang=js"
import style0 from "./IrWalletList.vue?vue&type=style&index=0&id=450074cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports